import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2, ArrowRight } from "lucide-react";
import { API, setToken } from "./auth";

export default function AdminLogin() {
    const nav = useNavigate();
    const [password, setPassword] = useState("");
    const [state, setState] = useState({ loading: false, error: "" });

    const submit = async (e) => {
        e.preventDefault();
        if (!password) return;
        setState({ loading: true, error: "" });
        try {
            const res = await axios.post(`${API}/admin/login`, { password });
            setToken(res.data.token);
            nav("/admin/dashboard");
        } catch (err) {
            setState({
                loading: false,
                error:
                    err.response?.status === 401
                        ? "Mot de passe incorrect."
                        : "Erreur de connexion. Réessayez.",
            });
        }
    };

    return (
        <div className="min-h-screen bg-ink text-white flex items-center justify-center px-4">
            <div className="absolute inset-0 hex-pattern opacity-15 pointer-events-none" />
            <div className="relative bg-white text-ink border-2 border-mint p-8 md:p-10 max-w-md w-full">
                <div className="flex items-center gap-3 mb-6">
                    <span className="w-10 h-10 bg-ink text-mint flex items-center justify-center">
                        <Lock size={18} />
                    </span>
                    <div>
                        <div className="font-display text-xs uppercase tracking-[0.3em] text-ink-muted">
                            SITMEC · Admin
                        </div>
                        <div className="font-display font-bold uppercase text-xl tracking-tight">
                            Connexion
                        </div>
                    </div>
                </div>

                <form onSubmit={submit} data-testid="admin-login-form">
                    <label className="label">Mot de passe</label>
                    <input
                        data-testid="admin-password"
                        type="password"
                        autoFocus
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="field"
                        placeholder="••••••••"
                    />
                    {state.error && (
                        <div
                            data-testid="admin-error"
                            className="mt-4 px-4 py-3 border border-destructive text-destructive text-sm"
                        >
                            {state.error}
                        </div>
                    )}
                    <button
                        type="submit"
                        data-testid="admin-login-submit"
                        disabled={state.loading}
                        className="mt-6 btn-primary w-full justify-center disabled:opacity-50"
                    >
                        {state.loading ? (
                            <Loader2 className="animate-spin" size={16} />
                        ) : (
                            <>
                                Se connecter
                                <ArrowRight size={16} />
                            </>
                        )}
                    </button>
                </form>

                <p className="mt-8 text-xs text-ink-muted text-center">
                    Accès réservé à l'administration SITMEC.
                </p>
            </div>
        </div>
    );
}
